import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getApi } from '../../utils/api/api';
import Loader from "../../utils/loader";
import { showToast } from "../../utils/toast";
import importImage from "../../utils/images/importImage";

const SpunImage = importImage("77.jpeg");
const FillImage = importImage("88.jpeg");


const Products = () => {
  const navigate = useNavigate();
  const baseUrl = "https://backend.tokoyarn.com/public/";
  
  const [productsData, setProductsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    try {
      const response = await getApi("buyer/get-latest-product");
      setProductsData(response.data.product.data);
    } catch (error) {
      console.error("Error fetching products:", error);
      showToast("error", "Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const totalPages = Math.ceil(productsData?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentProducts = Array.isArray(productsData) ? productsData.slice(startIndex, startIndex + itemsPerPage) : [];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleBidClick = (product) => {
    navigate(`/buyer-dashboard/${product.id}`, { state: { product } });
  };

  const handleEnquireClick = (product) => {
    navigate(`/buyer-dashboard/product-enquire/${product.id}`, { state: { product } });
  };
  const handleProductDetailClick = (product) => {
    navigate(`/buyer-dashboard/product-detail/${product.id}`, { state: { product } });
  };

  const renderQualityBadge = (grade) => {
    const colors = {
      A: "success",
      B: "success",
      C: "warning",
      D: "danger",
    };
    return (
      <span className={`badge bg-${colors[grade] || "secondary"} fs-6 shadow-sm mb-2`} >
        Grade {grade}
      </span>
    );
  };

  const renderSellerBadge = (grade) => {
    const colors = {
      A: "primary",
      B: "primary",
      C: "warning",
      D: "danger",
    };
    return (
      <span className={`badge bg-${colors[grade] || "secondary"} fs-6 shadow-sm`}>
        Seller : {grade}
      </span>
    );
  };

  const renderProductSpecs = (product) => {
    if (product.type === "Spun" && product.spun) {
      return (
        <div className="row g-2">
          <div className="col-6">
            <strong>End Use:</strong> {product.spun.end_use}
          </div>
          <div className="col-6">
            <strong>Technology:</strong> {product.spun.technology}
          </div>
          <div className="col-6">
            <strong>Ply:</strong>{" "}
            {product.spun.ply}
          </div>
          <div className="col-6">
            <strong>Application:</strong>{" "}
            {product.spun.application}
          </div>
          <div className="col-6">
            <strong>Count:</strong>{" "}
            {product?.spun?.count_from} - {product?.spun?.count_to}
          </div>
          <div className="col-6">
            <strong>IPI:</strong>{" "}
            {product.spun.ipi}
          </div>
        </div>
      );
    } else if (product.type === "Filament" && product.filament) {
      return (
        <div className="row g-2">
          <div className="col-6">
            <strong>Semi/Full Dull:</strong> {product.filament.dull}
          </div>
          <div className="col-6">
            <strong>Texturized:</strong> {product.filament.texturized}
          </div>
          <div className="col-6">
            <strong>Denier:</strong> {product.filament.dennier_from} - {product.filament.dennier_to}
          </div>
          <div className="col-6">
            <strong>No. Of Filament:</strong> {product.filament.filament_no_from} - {product.filament.filament_no_to}
          </div>

        </div>
      );
    }
    return null;
  };

  return (
    <div className="container py-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
        <h2 className="text-primary fw-bold mb-2">Latest Products</h2>
      </div>

      {loading ? (
        <Loader />
      ) : productsData.length > 0 ? (
        <div className="row g-4">
          {currentProducts.map((inventory) => (
            <div key={inventory.id} className="col-12">
              <div
                className="card border-0 shadow-lg flex-row flex-wrap align-items-stretch p-2"
                style={{
                  borderRadius: "12px",
                  transition: "0.3s",
                  overflow: "hidden",
                }}
              >
                {/* Image Section */}
                <div
                  className="col-12 col-md-4 p-2"
                  style={{ maxWidth: "350px" }}
                >
                  <img
                    src={
                      inventory.prevImages && inventory.prevImages.length
                        ? `${baseUrl}${inventory.prevImages[0]}`
                        : inventory.type === "Spun"
                        ? SpunImage
                        : FillImage
                    }
                    alt="Product"
                    className="w-100 h-100 rounded"
                    style={{
                      objectFit: "cover",
                      minHeight: "200px",
                      maxHeight: "250px",
                    }}
                  />
                </div>

                {/* Content Section */}
                <div className="col flex-grow-1 p-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <h5 className="card-title mb-1">
                        {inventory.type} Yarn
                      </h5>
                      <p className="text-muted small mb-0">
                        {inventory.type === "Spun"
                          ? `${inventory.spun?.category} ${inventory.spun?.sub_category
                            ? `- ${inventory.spun.sub_category}`
                            : ""
                          }`
                          : inventory.filament?.category}
                      </p>
                    </div>
                    {renderQualityBadge(inventory.quality_grade)}
                  </div>

                  {/*                  {inventory.type === "Filament" && (
  <p className="fw-bold text-success mb-2 fs-6">
    {`${inventory.filament.price_from} - ${inventory.filament.price_to}`} {inventory.price_type}
  </p>
)}*/}


                  <div className="mb-3">{renderProductSpecs(inventory)}</div>

                  <div className="mt-auto pt-3 border-top d-flex gap-2 flex-wrap">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handleProductDetailClick(inventory)}
                    >
                      <i className="bi bi-eye me-1"></i> View Details
                    </button>
                    {/*<button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => handleBidClick(product)}
                    >
                      <i className="bi bi-currency-dollar me-1"></i> Place Bid
                    </button>*/}
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => handleEnquireClick(inventory)}
                    // onClick={() => alert("Coming Soon")}
                    >
                      <i className="bi bi-currency-dollar me-1"></i> Enquire Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-5">
          <i className="bi bi-box-seam display-4 text-muted mb-3"></i>
          <h4 className="text-muted">No products found</h4>
        </div>
      )}

      {/* Pagination */}
      {!loading && productsData?.length > 0 && (
        <nav aria-label="Products pagination" className="mt-4">
          <ul className="pagination justify-content-center">
            {[...Array(totalPages)].map((_, i) => (
              <li
                key={i}
                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                onClick={() => handlePageChange(i + 1)}
              >
                <button className="page-link">{i + 1}</button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  );
};

export default Products;























